import { render } from "./FlipTransition.vue?vue&type=template&id=d495a810&ts=true"
import script from "./FlipTransition.vue?vue&type=script&lang=ts"
export * from "./FlipTransition.vue?vue&type=script&lang=ts"

import "./FlipTransition.vue?vue&type=style&index=0&id=d495a810&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__